import type {UIChild} from "../../../../stem-core/ui/UIBase";
import {BasePanelPage} from "../../PanelPage";

// TODO @branch this should not exist, it seems to be used when there isn't anything
export class PanelCollapsed extends BasePanelPage {
    getChildrenToRender(): UIChild[] {
        return [];
    }
}
